// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Iv9mhRIwOZgJnM2uvaVe{flex-direction:column;flex:1;display:flex}.LsoAICdd89M1WDPcupiG{flex:1;position:relative}.O4wp0TyG1gEP3nCqczQu{background:var(--background-neutral-default);border-radius:6px;padding:4px 8px}.TFOaMmGEG4UpuJ_Ql9j0{margin-bottom:8px;padding:0 16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historyContainer": `Iv9mhRIwOZgJnM2uvaVe`,
	"tableContainer": `LsoAICdd89M1WDPcupiG`,
	"rowCell": `O4wp0TyG1gEP3nCqczQu`,
	"alertContainer": `TFOaMmGEG4UpuJ_Ql9j0`
};
export default ___CSS_LOADER_EXPORT___;
